import { IApplicationState } from '../../types/store';

export const selectRegionId = (state: IApplicationState) => {
  return state.filters.regionId ?? undefined;
};
